import type { Env, EnvName } from '../api/types';

interface Props {
  value: EnvName | 'all';
  envs: Env[];
  onChange: (v: EnvName | 'all') => void;
}

export function EnvSelector({ value, envs, onChange }: Props) {
  const options: Array<{ id: EnvName | 'all'; label: string; count: number | null }> = [
    { id: 'all', label: 'all', count: envs.reduce((n, e) => n + e.host_count, 0) },
    ...(['dev', 'staging', 'prod'] as const).map((k) => ({
      id: k as EnvName,
      label: k,
      count: envs.find((e) => e.id === k)?.host_count ?? 0,
    })),
  ];

  return (
    <div className="flex items-center gap-1 rounded border border-cockpit-border bg-cockpit-panel p-0.5">
      {options.map((o) => {
        const active = value === o.id;
        return (
          <button
            key={o.id}
            type="button"
            onClick={() => onChange(o.id)}
            className={
              active
                ? 'rounded px-2.5 py-1 text-xs font-medium uppercase tracking-wider bg-cockpit-text text-cockpit-bg'
                : 'rounded px-2.5 py-1 text-xs font-medium uppercase tracking-wider text-cockpit-dim hover:text-cockpit-text'
            }
          >
            {o.label}
            {o.count !== null && (
              <span className={active ? 'ml-1.5 opacity-60' : 'ml-1.5 opacity-40'}>{o.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
